import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Toggle/Toggle.tsx
import { forwardRef } from "react";
import { Switch } from "@headlessui/react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var Toggle = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className,
      screenReaderLabel
    } = _b,
    rest = __objRest(_b, ["className", "screenReaderLabel"]);
  return /* @__PURE__ */jsxs(Switch, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:toggle", className)
  }, rest), {
    children: [/* @__PURE__ */jsx("span", {
      className: "pd:sr-only",
      children: screenReaderLabel
    }), /* @__PURE__ */jsx("span", {
      className: "pd:toggle__lever"
    })]
  }));
});
var Toggle_default = Toggle;
export { Toggle_default };